/**
 * 旧ユーザーストーリー図（`/user-stories/$usId`）を業務マップへ倒す。
 *
 * ストーリーは業務フローに置き換わった。旧 URL のブックマークを 404 にせず、業務フローを辿れる
 * 業務マップへ送る。**案件（`?pj=`）は持ったまま送る** — 落とすと、案件を選んで開いた利用者が
 * 案件の外れたマスターへ着き、外れたことは画面に出ない。
 *
 * 描画側で行き先を宣言する（`registry/common.tsx` と同じ形）。`beforeLoad` で `redirect` を投げる
 * 形は `only-throw-error` に当たる。
 *
 * **ルートに検索条件の検証器を張らない。** 張ると、倒すだけのこの URL が案件モードの画面として
 * 数えられ（`PJ_SEARCH_ROUTES`）、一瞬だけ案件の帯が出る。案件は URL から直に読む。
 *
 * @graph-stack spec-console
 * @graph-domain Engineering
 * @graph-business 旧ユーザーストーリー図の URL を、案件を引き継いだまま業務マップへ倒す。
 * @graph-connects usePjSearchNumber [calls] URL の案件番号を読む
 */
import { Navigate } from '@tanstack/react-router';

import { pjLinkSearch } from './pj-link.js';
import { usePjSearchNumber } from './receivers/pj-number.js';
import { BUSINESS_MAP_ROUTE } from './route-paths.js';

/**
 * 旧ストーリーの URL を、案件を引き継いで業務マップへ倒す。
 *
 * @returns 業務マップへの倒し
 * @graph-node {Function}
 * @graph-stack spec-console
 * @graph-domain Engineering
 * @graph-business 旧ユーザーストーリー図の URL を、案件を引き継いだまま業務マップへ倒す。
 * @graph-connects pjLinkSearch [calls] 案件を検索条件へ載せる
 */
export function LegacyUserStoryRedirect() {
  const pj = usePjSearchNumber();
  return (
    <Navigate
      to={BUSINESS_MAP_ROUTE}
      {...pjLinkSearch(pj === null ? undefined : String(pj))}
      replace
    />
  );
}
